import {
    posthogInit,
    posthogPageviewEventBasic,
    posthogEventBasicLinkClick,
} from "~/utils/posthog/basic";
import "./landing.css";

// Initialise posthog and fire a pageview tracking event
posthogInit();
posthogPageviewEventBasic();

const sheetOpen = document.getElementById("landing-sheet-open");
const sheetMenu = document.getElementById("landing-sheet-menu");
const sheetContent = document.getElementById("landing-sheet-content");
const sheetBlocker = document.getElementById("landing-sheet-blocker");
const sheetClose = document.getElementById("landing-sheet-close");

function openSheetMenu() {
    document.body.style.overflow = "hidden";
    sheetMenu.style.width = "250px";
    sheetBlocker.style.width = "100%";
    setTimeout(() => sheetContent.style.display = "flex", 150);
};

function closeSheetMenu() {
    document.body.style.overflow = "auto";
    sheetContent.style.display = "none";
    sheetMenu.style.width = 0;
    sheetBlocker.style.width = 0;
};

sheetOpen.addEventListener("click", openSheetMenu);
sheetMenu.addEventListener("click", (e) => e.stopPropagation());
sheetBlocker.addEventListener("click", closeSheetMenu);
sheetClose.addEventListener("click", (e) => {
    e.stopPropagation();
    closeSheetMenu();
});

const videoModalOpen = document.getElementById("video-modal-open");
const videoModalBlocker = document.getElementById("video-modal-blocker");
const videoModal = document.getElementById("video-modal");
const videoModalClose = document.getElementById("video-modal-close");
const videoModalPlayer = document.getElementById("video-modal-player");

function openVideoModal() {
    if (!videoModal.contains(videoModalPlayer)) {
        videoModal.appendChild(videoModalPlayer);
    }
    document.body.style.overflow = "hidden";
    videoModalBlocker.style.display = "block";
    videoModal.style.display = "grid";
    videoModalClose.style.display = "inline-block";
};

function closeVideoModal() {
    if (videoModal.contains(videoModalPlayer)) {
        videoModal.removeChild(videoModalPlayer);
    }
    document.body.style.overflow = "auto";
    videoModalBlocker.style.display = "none";
    videoModal.style.display = "none";
    videoModalClose.style.display = "none";
};

window.addEventListener('DOMContentLoaded', () => {
    // Add basic tracking to all internal simple <a> links
    document.querySelectorAll(`a[href^="/"], a[href^="https://${window.location.hostname}/"]`)
        .forEach((a) => {
            a.addEventListener('click', posthogEventBasicLinkClick);
        });

    // Prepare the video player
    if (videoModalOpen.dataset.state !== "disabled") {
        videoModalOpen.addEventListener("click", openVideoModal);
        videoModal.addEventListener("click", (e) => e.stopPropagation());
        videoModalBlocker.addEventListener("click", closeVideoModal);
        videoModalClose.addEventListener("click", (e) => {
            e.stopPropagation();
            closeVideoModal();
        });
    }
});
